import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Spinner,
} from "reactstrap";
import withRouter from "../../components/Common/withRouter";
import Breadcrumb from "../../components/Common/Breadcrumb";
import avatar from "../../assets/images/users/avatar-1.jpg";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const UserProfile = () => {

  document.title = "Profile | Admin";
const baseurl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
const authUser = JSON.parse(localStorage.getItem("authUser"));

  

  const [loading, setLoading] = useState(false);
  const [newAvatar, setNewAvatar] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      fullname: "",
      displayname: "",
      email: "",
      phone: "",
      address: "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },

    validationSchema: Yup.object({

      fullname: Yup.string()
        .required("Full Name is required"),

      displayname: Yup.string()
        .required("Display Name is required"),

      email: Yup.string()
        .email("Invalid Email")
        .required("Email is required"),

      phone: Yup.string()
        .required("Phone Number is required"),

      address: Yup.string()
        .required("Address is required"),

      currentPassword: Yup.string(),

      newPassword: Yup.string()
        .min(6, "Minimum 6 characters"),

      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("newPassword"), null],
          "Password does not match"
        ),

    }),

    onSubmit: async (values) => {

      try {

        setLoading(true);

        const formData = new FormData();

        formData.append("fullname", values.fullname);
        formData.append("displayname", values.displayname);
        formData.append("email", values.email);
        formData.append("phone", values.phone);
        formData.append("address", values.address);

        if (imageFile) {
          formData.append("photo", imageFile);
        }

        const res = await axios.post(
          baseurl + "/admin/profile-update",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        alert(res.data.message);

        loadProfile();

      } catch (err) {

        alert(
          err.response?.data?.message ||
          "Something went wrong"
        );

      } finally {

        setLoading(false);

      }

    },

  });

  useEffect(() => {
  loadProfile();
}, []);

const loadProfile = async () => {
  try {
    const res = await axios.get(`${baseurl}/admin/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        id: authUser.id,
      },
    });

    const profile = res.data.data;

    formik.setValues({
      fullname: profile.fullname || "",
      displayname: profile.displayname || "",
      email: profile.email || "",
      phone: profile.phone || "",
      address: profile.address || "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    if (profile.photo) {
      setNewAvatar(`${baseurl}/uploads/profile/${profile.photo}`);
    }
  } catch (err) {
    console.log(err);
  }
};

  const handleAvatarChange = (e) => {

    if (e.target.files.length > 0) {

      setImageFile(e.target.files[0]);

      setNewAvatar(
        URL.createObjectURL(e.target.files[0])
      );

    }

  };
  document.title = "Profile | Vekart.";

    return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumb title="Profile" breadcrumbItem="User Profile" />

          <Row>

            <Col lg="4">
              <Card>
                <CardBody>

                  <div className="text-center">

                    <img
                      src={newAvatar || avatar}
                      alt="Profile"
                      className="rounded-circle img-thumbnail"
                      style={{
                        width: "180px",
                        height: "180px",
                        objectFit: "cover"
                      }}
                    />

                    <div className="mt-3">

                      <Input
                        type="file"
                        accept="image/*"
                        onChange={handleAvatarChange}
                      />

                    </div>

                  </div>

                </CardBody>
              </Card>
            </Col>

            <Col lg="8">

              <Card>

                <CardBody>

                  <Form onSubmit={formik.handleSubmit}>

                    <Row>

                      <Col md="6">

                        <div className="mb-3">
                          <Label>Full Name</Label>

                          <Input
                            name="fullname"
                            value={formik.values.fullname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.fullname &&
                              formik.errors.fullname
                            }
                          />

                          <FormFeedback>
                            {formik.errors.fullname}
                          </FormFeedback>

                        </div>

                      </Col>

                      <Col md="6">

                        <div className="mb-3">

                          <Label>Display Name</Label>

                          <Input
                            name="displayname"
                            value={formik.values.displayname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.displayname &&
                              formik.errors.displayname
                            }
                          />

                          <FormFeedback>
                            {formik.errors.displayname}
                          </FormFeedback>

                        </div>

                      </Col>

                    </Row>

                    <Row>

                      <Col md="6">

                        <div className="mb-3">

                          <Label>Email</Label>

                          <Input
                            type="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.email &&
                              formik.errors.email
                            }
                          />

                          <FormFeedback>
                            {formik.errors.email}
                          </FormFeedback>

                        </div>

                      </Col>

                      <Col md="6">

                        <div className="mb-3">

                          <Label>Phone Number</Label>

                          <Input
                            name="phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.phone &&
                              formik.errors.phone
                            }
                          />

                          <FormFeedback>
                            {formik.errors.phone}
                          </FormFeedback>

                        </div>

                      </Col>

                    </Row>

                    <div className="mb-3">

                      <Label>Address</Label>

                      <Input
                        type="textarea"
                        rows="3"
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.address &&
                          formik.errors.address
                        }
                      />

                      <FormFeedback>
                        {formik.errors.address}
                      </FormFeedback>

                    </div>

                    <hr />

                    <h5 className="mb-3">
                      Change Password
                    </h5>

                    <Row>

                      <Col md="4">

                        <div className="mb-3">

                          <Label>Current Password</Label>

                          <Input
                            type="password"
                            name="currentPassword"
                            value={formik.values.currentPassword}
                            onChange={formik.handleChange}
                          />

                        </div>

                      </Col>

                      <Col md="4">

                        <div className="mb-3">

                          <Label>New Password</Label>

                          <Input
                            type="password"
                            name="newPassword"
                            value={formik.values.newPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.newPassword &&
                              formik.errors.newPassword
                            }
                          />

                          <FormFeedback>
                            {formik.errors.newPassword}
                          </FormFeedback>

                        </div>

                      </Col>

                      <Col md="4">

                        <div className="mb-3">

                          <Label>Confirm Password</Label>

                          <Input
                            type="password"
                            name="confirmPassword"
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.confirmPassword &&
                              formik.errors.confirmPassword
                            }
                          />

                          <FormFeedback>
                            {formik.errors.confirmPassword}
                          </FormFeedback>

                        </div>

                      </Col>

                    </Row>

                    <div className="text-end mt-4">

                      <Button
                        color="primary"
                        type="submit"
                        disabled={loading}
                      >

                        {loading ? (
                          <>
                            <Spinner size="sm" />
                            {" "}Updating...
                          </>
                        ) : (
                          "Update Profile"
                        )}

                      </Button>

                    </div>

                  </Form>

                </CardBody>

              </Card>

            </Col>

          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);